import {UsersService} from "../services/UsersService";
import React, {useEffect, useState, useRef} from "react";
import Loader from "../components/Loader";
import {Outlet, useNavigate, useParams} from "react-router-dom";
import {setTitle, setBreadcrumbs, setSearchHandler, setSearchString, setCreateButton} from "../actions/main";
import {useDispatch, useSelector} from "react-redux";
import {MultiSelect} from "primereact/multiselect";
import {classNames} from 'primereact/utils';
import {useFormik} from "formik";
import {InputText} from "primereact/inputtext";
import {Calendar} from "primereact/calendar";
import PhoneInput from "react-phone-input-2";
import {Toast} from "primereact/toast";
import {Message} from "primereact/message";
import {Image} from "primereact/image";
import {Dialog} from "primereact/dialog";
import {FileUpload} from "primereact/fileupload";
import {Button} from "primereact/button";
import startsWith from 'lodash.startswith';


export default function UserEdit2(props) {

    const userData = useSelector(function (state) {
        return state.auth.userData
    });
    const departments = useSelector(function (state) {
        return state.departments
    });

    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });

    const locationParams = useParams()
    let navigation = useNavigate();

    const toast = useRef(null);
    const phoneRef = useRef(null);
    const [user, setUser] = useState(false)
    const [isNewUser, setIsNewUser] = useState(false)
    const [avatarDialogVisible, setAvatarDialogVisible] = useState(false);

    // const [departments, setDepartments] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false)
    const [mainFormSending, setMainFormSending] = useState(false)
    const tabs = [
        {label: 'Работа', id: 'work'},
        {label: 'Финансы', id: 'money'},
        // {label: 'Обучение', id: 'learning'},
        {label: 'Документы', id: 'documents'},

        {label: 'Доступ', id: 'access'},
        {label: 'Пароль', id: 'password'},
    ]
    const [activeTab, setActiveTab] = useState(false)

    const show = () => {
        toast.current.show({severity: 'success', summary: 'Form Submitted', detail: formik.values.value});
    };

    const dispatch = useDispatch()


    const handleTabClick = (tab) => {

        setActiveTab(tab)
        navigation(tab)
    }

    const handleUserSave = (e) => {
        // e.target.classList.add('disabled')
        // this.setState({dataSending: true})
        // e.preventDefault()
        // sendRequest('users/' + this.state.user.id, 'PUT', this.state.formData, true).then(response => {
        //     if (response.errors) {
        //
        //     }
        //     e.target.classList.remove('disabled')
        //     this.setState({dataSending: false})
        // })
    }


    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return isFormFieldInvalid(name) ? <small className="p-error">{formik.errors[name]}</small> :
            <small className="p-error">&nbsp;</small>;
    };


    const formik = useFormik({

        validate: (data) => {
            let errors = {};

            if (!data.username) {
                errors.username = 'Обязательное поле!';
            }
            if (!data.email) {
                errors.email = 'Обязательное поле!';
            }
            if (!data.phone) {
                errors.phone = 'Обязательное поле!';
            }
            if (!data.pc_departments_ids || data.pc_departments_ids === []) {
                errors.pc_departments_ids = 'Обязательное поле!';
            }
            return errors;
        },
        onSubmit: (data) => {
            // data && show(data);
            setMainFormSending(true)

            let phone = formik.values.phone
            let phone_prefix = phoneRef.current.state.selectedCountry.countryCode

            if(phone_prefix){
                phone = phone.substring(phone_prefix.length, phone.length)
            }

            const sendData = {
                username: formik.values.username,
                pc_birthday: formik.values.birthday ? formik.values.birthday.toLocaleDateString() : '',
                phone: phone,
                phone_prefix: phone_prefix,
                pc_departments_ids: formik.values.pc_departments_ids,
                email: formik.values.email
            }



            if(user.id !== 'new_user') {
                UsersService.Update(user.id, sendData).then((response) => {
                    if (!response) {
                        toast.current.show({
                            severity: 'error',
                            summary: 'Ошибка',
                            detail: 'Произошла ошибка.',
                            life: 3000
                        });
                        setMainFormSending(false)
                        return
                    }


                    toast.current.show({
                        severity: 'success',
                        summary: 'Успех',
                        detail: 'Данные пользователя успешно сохранены.',
                        life: 3000
                    });
                    setMainFormSending(false)
                })
            } else {
                UsersService.Create({...sendData, user_type: 'worker'}).then((response) => {
                    console.log(response)
                    setMainFormSending(false)
                    if(response && response.errors){
                        response.errors.map((error) => {
                            formik.setFieldError(error.field, error.message)
                        })
                    } else {


                        navigation('/users/' + response.id)
                    }
                })
            }
            // formik.resetForm();
        },
        // enableReinitialize: true
    });

    const updateCurrentUser = () => {
        dispatch(setSearchHandler(null))
        dispatch(setSearchString(null))
        dispatch(setCreateButton(null))
        if(locationParams.userId !== 'create') {
            UsersService.GetById(locationParams.userId, {expand: 'departments'}).then((response) => {
                dispatch(setTitle(response.username))
                dispatch(setBreadcrumbs([
                    {'label': 'Сотрудники', link: 'users'},
                    {'label': response.username, link: 'users/' + response.id},
                ]))
                setUser(response)
                setIsNewUser(false)

            })
        }
        if(locationParams.userId === 'create'){
            dispatch(setTitle('Новый пользователь'))
            dispatch(setBreadcrumbs([
                {'label': 'Сотрудники', link: 'users'},
            ]))
            setIsNewUser(true)
            setUser({id: 'new_user'})
        }
    }


    useEffect(() => {
        updateCurrentUser()
    }, [locationParams]);

    useEffect(() => {
        if (formik.values) {
            setIsLoaded(true)
        }
    }, [formik.values]);

    useEffect(() => {
        if (user.id && user.id !== 'new_user') {

            const departmentsIds = []
            user.departments.map((el, i) => {
                departmentsIds.push(el.id)
            })

            formik.setValues({
                username: user.username,
                birthday: user.birthday_base ? new Date(user.birthday_base) : '',
                phone: user.phone_prefix + user.phone,
                pc_departments_ids: departmentsIds,
                email: user.email
            })
        }
        if(user.id && user.id === 'new_user'){

            formik.setValues({
                username: '',
                birthday: '',
                phone: '',
                pc_departments_ids: null,
                email: ''
            })
        }
    }, [user]);


    const uploadAvatarHandler = (e) => {
        setAvatarDialogVisible(false)
        updateCurrentUser()
    }

    const handleToArchive = (e) => {
        UsersService.ChangeUserStatus(locationParams.userId, 2).then((response) => {
            toast.current.show({severity:'success', summary: 'Выполнено', detail:'Пользователь перемещен в архив.', life: 3000});
            updateCurrentUser()
        })
    }

    const handleFromArchive = (e) => {
        UsersService.ChangeUserStatus(locationParams.userId, 1).then((response) => {
            toast.current.show({severity:'success', summary: 'Выполнено', detail:'Пользователь восстановлен из архива.', life: 3000});
            updateCurrentUser()
        })
    }

    const handleChangeType = (type) => {
        UsersService.ChangeUserType(locationParams.userId, type).then((response) => {
            toast.current.show({severity:'success', summary: 'Выполнено', detail:'Тип пользователя изменен.', life: 3000});
            updateCurrentUser()
        })
    }

    const uploadAvatarHeaderTemplate = (options) => {
        const {className, chooseButton, uploadButton, cancelButton} = options;
        return (
            <div className={className} style={{backgroundColor: 'transparent', display: 'flex', alignItems: 'center'}}>
                {chooseButton}
            </div>
        )
    }
    const uploadAvatarEmptyTemplate = () => {

        return (
            <div className="d-flex align-items-center flex-column">
                <i className="pi pi-image m-t-3 p-3" style={{
                    fontSize: '2em',
                    borderRadius: '50%',
                    backgroundColor: 'var(--surface-b)',
                    color: 'var(--surface-d)'
                }}></i>
                <span className="my-2">
                    Перетяните изображение в область
                </span>
            </div>
        );

    }

    if (!user || !userData) {
        return (<Loader/>)
    }




    return (
        <div className={'edit-profile'}>
            <Toast ref={toast}></Toast>
            {isLoaded &&
                <div className="row">
                    <div className="col-xl-4">
                        <div className="card">


                            <div className="card-body">
                                <form onSubmit={formik.handleSubmit}>

                                    <Dialog header="Загрузите новый аватар" visible={avatarDialogVisible}
                                            onHide={() => setAvatarDialogVisible(false)} style={{
                                                width: '50%'
                                    }}>
                                        <div className={'p-t-10'}>
                                            <FileUpload accept="image/*" name={'file'}
                                                        url={"http://yii2.easytickets.pro/users/upload?user_id=" + user.id + "&access-token=" + localStorage.getItem('user') + '&type=&multi=0'}
                                                        chooseLabel={'Выбрать изображение'} onUpload={uploadAvatarHandler}
                                                        emptyTemplate={uploadAvatarEmptyTemplate}
                                                        headerTemplate={uploadAvatarHeaderTemplate} auto/>
                                        </div>
                                    </Dialog>

                                    {!isNewUser &&
                                    <div className="profile-title m-b-10">
                                        <div className="media">
                                            <Image imageClassName="img-70 rounded-circle" className={'rounded-circle'}
                                                   alt=""
                                                   src={'http://yii2.easytickets.pro' + user.avatar} preview/>
                                            <div className="media-body">
                                                <h3 className="mb-1 f-20 txt-primary">{formik.values.username}</h3>

                                                    <a href="#" className={'f-12'} onClick={(e) => setAvatarDialogVisible(true)}>Изменить
                                                        аватар</a>


                                            </div>
                                        </div>
                                    </div>
                                    }


                                    <div className={'d-flex flex-column gap-2'}>
                                        <label htmlFor="input_value">ФИО</label>
                                        <InputText name="username"
                                                   value={formik.values.username}
                                                   onChange={(e) => {
                                                       formik.setFieldValue('username', e.target.value);
                                                   }}
                                                   className={classNames({'p-invalid': isFormFieldInvalid('username')})}
                                        />


                                    </div>
                                    {getFormErrorMessage('username')}

                                    <div className="row">
                                        <div className="col-md-7">
                                            <div className={'d-flex flex-column gap-2'}>
                                                <label htmlFor="input_value">Телефон</label>
                                                <PhoneInput ref={phoneRef} specialLabel={''}
                                                            value={formik.values.phone}
                                                            onChange={(e) => formik.setFieldValue('phone', e)}
                                                            inputClass={'p-inputtext p-component ' + classNames({'p-invalid': isFormFieldInvalid('phone')})}
                                                            disabled={false}  isValid={(inputNumber, country, countries) => {
                                                    return countries.some((country) => {
                                                        return startsWith(inputNumber, country.dialCode) || startsWith(country.dialCode, inputNumber);
                                                    });
                                                }}/>


                                            </div>
                                            {getFormErrorMessage('phone')}
                                        </div>
                                        <div className="col-md-5">
                                            <div className={'d-flex flex-column gap-2'}>
                                                <label htmlFor="user-birthday">Дата рождения</label>

                                                <Calendar
                                                    id={'user-birthday'}
                                                    value={formik.values.birthday}
                                                    onChange={(e) => {
                                                        formik.setFieldValue('birthday', e.target.value);
                                                    }}
                                                    // ref={birthdayRef}
                                                    dateFormat={"dd.mm.yy"}
                                                    // showIcon={true}
                                                    // locale={'ru'}
                                                    className={classNames({'p-invalid': isFormFieldInvalid('birthday')})}
                                                />
                                            </div>
                                            {getFormErrorMessage('birthday')}
                                        </div>
                                    </div>


                                    <div className={'d-flex flex-column gap-2'}>
                                        <label htmlFor="input_value">Email</label>
                                        <InputText name="username"
                                                   value={formik.values.email}
                                                   onChange={(e) => {
                                                       formik.setFieldValue('email', e.target.value);
                                                   }}
                                                   className={classNames({'p-invalid': isFormFieldInvalid('email')})}
                                        />


                                    </div>
                                    {getFormErrorMessage('email')}


                                    {(userData && departments) ?
                                        (<div className={'d-flex flex-column gap-2'}>
                                            <label htmlFor="input_value">Филиал</label>
                                            <MultiSelect
                                                         placeholder={'Выберите филиал'}
                                                         options={departments.map((el) => {
                                                             return {value: el.id, label: el.name}
                                                         })}

                                                         // selectedItemTemplate={(el) => el && departments && departments.find((e) => e.id === el).name}
                                                         value={formik.values.pc_departments_ids}
                                                         // optionValue={'value'}
                                                         // useOptionAsValue={false}
                                                         // optionLabel={'label'}
                                                display={'chip'}
                                                         onChange={(e) => formik.setFieldValue('pc_departments_ids', e.value)}
                                            />
                                            {getFormErrorMessage('pc_departments_ids')}
                                        </div>)

                                        : <Loader/>}


                                    {/*<small>Указывается общая для всех филиалов.</small>*/}

                                    {/*<Divider/>*/}


                                    {/*<button type={'submit'}*/}
                                    {/*        className={'btn btn-primary m-t-30'}>Сохранить*/}
                                    {/*</button>*/}
                                    <Button type={'submit'} label={'Сохранить'}/>

                                    {mainFormSending && <Loader/>}

                                </form>
                            </div>


                        </div>
                    </div>
                    {!isNewUser &&
                    <div className="col-xl-8">


                        <div className="card project-list">


                            <div className="row">

                                <div className="col-md-12 p-0 d-flex justify-content-between align-items-center">


                                    <ul className="nav nav-tabs border-tab">
                                        {tabs.map((tab, k) => {
                                            return (
                                                <li className={'nav-item'} key={'tab-' + k}>
                                                    <a href={'#'} onClick={(e) => {
                                                        e.preventDefault();
                                                        handleTabClick(tab.id)
                                                    }}
                                                       className={'nav-link ' + (activeTab === tab.id ? 'active' : '')}>{tab.label}</a>
                                                </li>
                                            )
                                        })}
                                    </ul>

                                    <div className={'m-l-auto'}>
                                         </div>

                                </div>

                            </div>

                        </div>

                        {!formik.values.pc_departments_ids.includes(currentDepartment) ? <>
                            <Message severity="warn"
                                     text="Необходимо выбрать один из привязанных к пользователю филиалов."
                                     className={'m-b-30'}/>
                        </> : <Outlet/>}


                    </div>
                    }
                </div>
            }

            {isLoaded && !isNewUser && <div className="footer footer-fix">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-12">
                            <div className="d-flex justify-content-between">
                                {/*<div>Пользователь в разделе: {user.status === 2 ? 'архив' : (user.user_type === 'worker' ? 'пользователь' : 'персонал')}</div> */}

                                <div className={'d-flex gap-3'}>
                                    {user.status !== 2 && user.user_type === 'worker' && <Button  className={'p-button-light p-button-outlined'} onClick={(e) => handleChangeType('additional')} label={'Перенести в персонал'}/>}
                                    {user.status !== 2 && user.user_type === 'additional' && <Button  onClick={(e) => handleChangeType('worker')} className={'p-button-light p-button-outlined'} label={'Перенести в пользователи'}/>}
                                    {user.status === 2 && <>
                                        <Button icon={'pi pi-briefcase'} onClick={handleFromArchive}  label={'Восстановить из архива'} className="p-button-primary p-button-outlined"/>
                                    </>}
                                    {user.status !== 2 && <>
                                        <Button icon={'pi pi-briefcase'} onClick={handleToArchive}  label={'В архив'} className="p-button-warning p-button-outlined"/>
                                    </>}
                                </div>


                                <div className={'m-l-auto d-flex gap-3'}>





                                    {/*<Button className={'p-button-danger p-button-outlined'} label={'Удалить'} icon={'pi pi-trash'} />*/}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }

        </div>
    )

}

